import { Navigate, useLocation } from 'react-router';
import { legacyTarget, movedTarget } from '../../nav/hubs';
import { NotFoundPage } from '../ErrorPages';

/** A former list URL or removed hub: opens its hub tab, keeping the query (see `LEGACY_REDIRECTS`, `MOVED_TABS`). */
export function LegacyRedirect() {
  const { pathname, search, hash } = useLocation();
  const to = legacyTarget(pathname, search) ?? movedTarget(pathname, search);
  return to ? <Navigate to={`${to}${hash}`} replace /> : <NotFoundPage />;
}
